module.exports = __webpack_public_path__ + "img/Mask Group 82.ab825cb6.svg";